import React from 'react';
export function ProgramsHero() {
  return <section className="bg-ink py-20 text-center px-4" data-id="element-2873">
      <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-2874">
        Storm Taekwondo Classes & Programs
      </h1>
      <p className="text-xl text-gray-warm max-w-2xl mx-auto" data-id="element-2875">
        From first-time kids to adults, families, competitors, and summer camp
        students, Storm has a class or program designed to help each student
        grow.
      </p>
    </section>;
}